import styled from 'styled-components';
import h4Styles from '../styles/h4Styles';
var Heading4 = styled.h4.withConfig({
  displayName: "Heading4",
  componentId: "qrwn46-0"
})(["", ""], h4Styles);
export default Heading4;